import React, { useState, useEffect, useContext } from 'react';

import { axios } from '../services/ServiceUtils';

const ConfigContext = React.createContext();
const { Provider, Consumer } = ConfigContext;

export const useConfigContext = () => useContext(ConfigContext);

const ConfigProvider = props => {
  const [config, setConfig] = useState({
    BOOMERANG_URL: '',
    BOOMERANG_BEACON_URL: '',
    OMNITURE_URL: '',
    MBOX_URL: '',
    REGIONS: [],
    allowedHeaders: 'en-us,en-ca,fr-ca',
    DI_ENDPOINT_CA: '',
    DI_ENDPOINT_GCP: '',
    CP_CANADA_URL: '',
    TOGGLE: {
      toggleLanguageSelector: false,
    },
    error: false,
    errorStatus: false,
    isPilot: false,
  });

  const { children } = props;

  const configError = status => {
    setConfig({
      BOOMERANG_URL: '',
      BOOMERANG_BEACON_URL: '',
      OMNITURE_URL: '',
      MBOX_URL: '',
      REGIONS: [],
      allowedHeaders: 'en-us,en-ca,fr-ca',
      DI_ENDPOINT_GCP: '',
        DI_ENDPOINT_CA: '',
      CP_CANADA_URL: '',
      TOGGLE: {
        toggleLanguageSelector: false,
      },
      error: true,
      errorStatus: status,
    });
  };

  useEffect(() => {
    axios
      .get('config')
      .then(result => {
        if (!result.data.BOOMERANG_URL) {
          configError(200);
        } else {
          setConfig({
            BOOMERANG_URL: result.data.BOOMERANG_URL,
            BOOMERANG_BEACON_URL: result.data.BOOMERANG_BEACON_URL,
            OMNITURE_URL: result.data.OMNITURE_URL,
            MBOX_URL: result.data.MBOX_URL,
            REGIONS: result.data.REGIONS,
            allowedHeaders: result.data?.ALLOWED_HEADERS?.toLowerCase() || 'en-us,en-ca,fr-ca',
            DI_ENDPOINT_GCP: result.data.DI_ENDPOINT_GCP,
            DI_ENDPOINT_CA: result.data.DI_ENDPOINT_CA,
            CP_CANADA_URL: result.data.CP_CANADA_URL,
            TOGGLE: result.data.TOGGLE,
            error: false,
            errorStatus: false,
            isPilot: result.data.isPilot,
          });
        }
      })
      .catch(e => {
        configError(e.response.status);
        // eslint-disable-next-line
        console.error('request error', e.response.status);
      });
  }, []);

  return <Provider value={config}>{children}</Provider>;
};

export { ConfigProvider, Consumer as ConsumerProvider };
export default ConfigContext;
